import React, { useEffect, useState } from "react";
import GoogleLogin from "react-google-login";
import { gapi } from "gapi-script";
import "./loginform.css";
import { useNavigate } from "react-router-dom";
import { baseUrl } from '../shared';
import axios from "axios";
import { setGlobalState, useGlobalState } from '../state/index';
import { useAuth } from './useAuth';

export default function AutoLoginForm() {


    const [errorMessage, setErrorMessage] = useState("");
    const [errorDistrictMSG, setErrorDistrictMSG] = useState("");
    const [errorStudentMSG, setErrorStudentMSG] = useState("");
    const [errorDOBMSG, setErrorDOBMSG] = useState("");

    const [districtId, setDistrictId] = useState();
    const [studentID, setStudentID] = useState();

    const navigate = useNavigate();
    const { login } = useAuth();

    // Set the states for day, month, and year
    const [day, setDay] = useState('');
    const [month, setMonth] = useState('');
    const [year, setYear] = useState('');



    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const urlDistrictId = params.get("districtID");
        const urlStudentID = params.get("studentID");
        const urlDOB = params.get("dob");
        const urlSEAccessReadOnly = params.get("seaccessreadonly");

        // Handle SEAccessReadOnly parameter
        if (urlSEAccessReadOnly) {
            const isReadOnly = urlSEAccessReadOnly.toLowerCase() === "true";
            setGlobalState("SEAccessReadOnly", isReadOnly);
            sessionStorage.setItem("SEAccessReadOnly", isReadOnly.toString());
        }

        if (urlDistrictId && urlStudentID && urlDOB) {
            setDistrictId(urlDistrictId);
            setStudentID(urlStudentID);

            const [urlYear, urlMonth, urlDay] = urlDOB.split("-");
            setYear(urlYear);
            setMonth(urlMonth);
            setDay(urlDay);
        }
    }, []);

    useEffect(() => {
        setTimeout(() => {
            popup();
        }, 500);
    }, [districtId, studentID, month, day, year]);



    const popup = () => {

        const url = baseUrl + 'api/Login/StudentLoginWithPassCode';
        const data = {
            "districtID": districtId,
            "studentID": studentID,
            "dob": `${year}-${month}-${day}`,
        }
        setErrorDistrictMSG("");
        setErrorDOBMSG("");
        setErrorStudentMSG("");
        setErrorMessage("");

        if (districtId && studentID && year && month && day) {
            axios.post(url, data)
                .then((result) => {
                    const loginResult = result.data;
                    if (loginResult && loginResult !== "Student Code does not exist") {
                        let DOB = "DOB";
                        loginResult[DOB] = `${month}-${day}-${year}`;
                        console.log("result " + result);
                        setGlobalState("authtoken", result.data.authtoken);
                        login(result.data.authtoken);
                        console.log(result.data.data.firstName)
                        setGlobalState("StudentKey", result.data.data.studentKey);
                        setGlobalState("FirstName", result.data.data.firstName);
                        setGlobalState("LastName", result.data.data.lastName);
                        setGlobalState("FullName", result.data.data.fullName);
                        setGlobalState("DistrictID", result.data.data.districtID);
                        setGlobalState("HideTeksTracker", result.data.data.hideTeksTracker);
                        sessionStorage.setItem("FullName", result.data.data.fullName);
                        sessionStorage.setItem("studentkey", result.data.data.studentKey);
                        sessionStorage.setItem("districtID", districtId);
                        sessionStorage.setItem("DistrictName", result.data.data.districtName);
                        sessionStorage.setItem('authToken', result.data.authtoken);
                        sessionStorage.setItem("HideTeksTracker", result.data.data.hideTeksTracker);
                        if (result.data.data.studentExplorer_LoginAutoComplete) {
                            // Save the details for auto-login
                            localStorage.setItem("districtId", districtId);
                            localStorage.setItem("studentID", studentID);
                            localStorage.setItem("dob", `${year}-${month}-${day}`);
                        }
                        // sessionStorage.setItem("authenticationToken", result.data.authtoken);
                        sessionStorage.setItem("HomeFormData", JSON.stringify({
                        ...loginResult,
                        DOB: data.dob
                        }));
                        navigate("/HomeForm")
                    } else {
                        setErrorMessage("Student combination not found. Please check District ID, Student ID, or Date of Birth.");
                    }
                })
                .catch((error) => {
                    console.log(error)
                })
        } else {
            if (!districtId) {
                setErrorDistrictMSG("District ID is required");
            } if (!studentID) {
                setErrorStudentMSG("Student ID is required");
            } if (!year || !month || !day) {
                setErrorDOBMSG("Date of birth is required");
            }
        }
    }


    return (
        <div className="signing-in">
            {errorDistrictMSG && <span style={{ color: "red", marginBottom: "15px", marginTop: "-40px" }}>{errorDistrictMSG}</span>}

            {errorStudentMSG && <span style={{ color: "red", marginBottom: "15px", marginTop: "-28px" }}>{errorStudentMSG}</span>}

            {errorDOBMSG && <span style={{ color: "red", marginBottom: "15px", marginTop: "-28px" }}>{errorDOBMSG}</span>}

            {errorMessage && <span style={{ color: "red", marginBottom: "5px", textAlign: "center", padding: "0 4px", fontSize: "16px" }}>{errorMessage}</span>}

            <span style={{ fontSize: "28px" }}>Signing in...</span>
            <span className="spinner"></span>
        </div>
    )
}

